export default "__VITE_ASSET__DXE9EmY6__"